import { useMutation, useQueryClient } from "@tanstack/react-query";
import { parseListResponse, parseResponse } from "lib/fetch";
import type { NoteInterface } from "types/note";
import {
    createNoteRequest,
    getFeedbacksRequest,
    getNotesRequest,
    getNotesToUserRequest,
    getUserNotesRequest,
} from "lib/api/note";

export const fetchNotes = (params?: HashMap<unknown>) =>
    parseListResponse<NoteInterface>(getNotesRequest(params));

export const fetchFeedbacks = () =>
    parseResponse<{ notes: NoteInterface[] }>(getFeedbacksRequest());

export const fetchNotesToUser = (id?: string, params?: HashMap<unknown>) => {
    if (!id) {
        return Promise.reject(new Error("Missing user id")) as unknown as Promise<NoteInterface[]>;
    }
    return parseResponse<NoteInterface[]>(getNotesToUserRequest(id, params));
};

export const fetchUserNotes = (id?: string, params?: HashMap<unknown>) =>
    parseResponse<NoteInterface[]>(getUserNotesRequest(id, params));

export const createNote = (data: HashMap<unknown>) =>
    parseResponse<NoteInterface>(createNoteRequest(data));

export const noteKeys = {
    all: ["note"] as const,
    lists: () => [...noteKeys.all, "list"] as const,
    feedbacks: () => [...noteKeys.all, "feedbacks"] as const,
};

export const useCreateNote = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: HashMap<unknown>) => createNote(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: noteKeys.all });
        },
    });
};
